import React, { Component } from "react";
// import fetch from "isomorphic-fetch";
import { GoogleMap, Marker, withGoogleMap, InfoWindow } from "react-google-maps";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";
import PropTypes from "prop-types";

const MarkerClustererGoogleMap = withGoogleMap((props) => (
  <GoogleMap
    ref={props.onMapMounted}
    defaultZoom={10}
    zoom={10}
    center={{
      lat: props.markers.length > 0 ? props.markers[0].latitude : -24.397,
      lng: props.markers.length > 0 ? props.markers[0].longitude : 135.644,
    }}
    defaultCenter={{ lat: -24.397, lng: 135.644 }}
    onDragEnd={props.onBoundsChanged}
    onZoomChanged={props.onBoundsChanged}
  >
    <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}>
      {props.markers.map((marker) =>
        marker.deviceID &&
          marker.deviceID &&
          marker.latitude &&
          marker.longitude ? (
            <Marker
              onClick={() => {
                props.navigate(marker.deviceID);
              }}
              position={{ lat: marker.latitude, lng: marker.longitude }}
              key={marker.deviceID}
            >
              <InfoWindow >
                <div 
                style={{
                  color: marker.deviceID.includes('rev-nbn') ? 'red' : 'blue',
                  padding: 12
                }}
                onClick={() => {
                  props.navigate(marker.deviceID);
                }}>
                  {marker.deviceID}
                </div>
              </InfoWindow>
            </Marker>
          ) : (
            ""
          )
      )}
    </MarkerClusterer>
  </GoogleMap>
));

class SymbioticMarkerClusterer extends Component {
  mapRef = {};

  componentWillMount() {
    this.mapRef = {};
  }

  onMapMounted = (ref) => {
    this.mapRef = ref;
  };

  onBoundsChanged = () => {
    this.props.onBoundsChanged(this.mapRef.getBounds());
  };

  render() {
    return (
      <MarkerClustererGoogleMap
        onMapMounted={this.onMapMounted}
        containerElement={
          <div className="embed-responsive embed-responsive-16by9 googleMap" />
        }
        navigate={(deviceID) => {
          this.props.navigate(deviceID);
        }}
        mapElement={<div className="embed-responsive-item" />}
        markers={this.props.markerData}
        onBoundsChanged={this.onBoundsChanged}
      />
    );
  }
}

SymbioticMarkerClusterer.propTypes = {
  markerData: PropTypes.array.isRequired,
};

export default SymbioticMarkerClusterer;



// WEBPACK FOOTER //
// ./app/routes/devices/Components/SymbioticMarkerClusterer.js